import { BANK_RECEIPT_REQUEST, CREATE_BANK_RECEIPT, GET_BANK_RECEIPTS, UPDATE_BANK_RECEIPT, DELETE_BANK_RECEIPT,
  BANK_RECEIPT_REQUEST_FAILURE, BANK_RECEIPT_REQUEST_SUCCESS, GET_BANK_RECEIPTS_PAGE } from '../types';

const initialState = {
  bankReceipts: [],
  bankReceiptsPage: [],
  page: 1,
  pageSize: 10,
  search: '',
  where: {},
  total: 0,
  loading: false,
  error: null,
};

const bankReceiptReducer = (state = initialState, action) => {
  switch (action.type) {
    case BANK_RECEIPT_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_BANK_RECEIPTS: {
      return {
        ...state,
        bankReceipts: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_BANK_RECEIPTS_PAGE: {
      const { data, total, page, pageSize, search, where } = action.payload || {};
      return {
        ...state,
        bankReceiptsPage: [...data],
        total,
        page,
        pageSize,
        search: search || '',
        where: where || {},
        loading: false,
        error: null
      }
    }
    case CREATE_BANK_RECEIPT: {
      return {
        ...state,
        bankReceipts: [action.payload, ...state.bankReceipts],
        loading: false,
        error: null
      };
    }
    case UPDATE_BANK_RECEIPT: {
      const bankReceiptsData = state.bankReceipts.slice(0);
      const uIndex = bankReceiptsData.findIndex((data) => data.id === action.payload.id);
      bankReceiptsData.splice(uIndex, 1, { ...action.payload.data });
      return {
        ...state,
        bankReceipts: [ ...bankReceiptsData ],
        loading: false,
        error: null
      };
    }
    case DELETE_BANK_RECEIPT: {
      const bankReceipts = state.bankReceipts?.slice(0);
      const index = bankReceipts.findIndex((data) => data.id === action.id);
      if (index > -1) {
        bankReceipts.splice(index, 1);
      }
      return {
        ...state,
        bankReceipts: [...bankReceipts],
        loading: false,
        error: null
      }
    }
    case BANK_RECEIPT_REQUEST_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: null
      }
    }
    case BANK_RECEIPT_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default bankReceiptReducer;